import EnrolmentsAdapter from './base';

export default class Identifier extends EnrolmentsAdapter {
  modelNamePlural = 'identifiers';
}
